import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"

import { defaultConfig } from "./config"
import { unbindOriginalSearch } from "./helpers"

import "./styles/index.css"

unbindOriginalSearch('x#HeaderSearchForm')
unbindOriginalSearch("x.search-bar--page")

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: "x#Search",
    contentCssSelector: "#NostoCollectionAjaxContent",
    serpUrlMapping: {
        query: "q",
    },
    serpPath: '/search',
    serpPathRedirect: true,
    serpQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "name",
                "imageUrl",
                "thumbUrl",
                "alternateImageUrls",
                "brand",
                "availability",
                "price",
                "listPrice",
                "skus.id", 
                "tags1",
                'customFields.key', 'customFields.value'
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0,
        },
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "name",
                "imageUrl",
                "thumbUrl",
                "brand",
                "availability",
                "price",
                "listPrice",
            ],
            size: defaultConfig.autocompleteProductsSize,
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"],
        },
    },
    compressUrlParameters: true,
    categoryCssSelector: '#NostoCollectionAjaxContent',
       categoryQuery() {
        const catId = document.querySelector(".nosto_category > .id")?.textContent;

        return {
            name: 'serp',
            products: {
                categoryId: catId,
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },

}).then(() => {
    const isCatPage = document.querySelector("#NostoCollectionAjaxContent .nosto_category"); 

    // if (isCatPage) {
    //     document.querySelector("body")?.classList.add("ns-serp-cm");
    // }

    const nativePagination = document.querySelector("x.nosto-pagination")
    const predictiveSearch = document.querySelector("x#search-bar--page")
    
    if (nativePagination) {
        nativePagination.remove()
    }
    if (predictiveSearch) {
        predictiveSearch.remove()
    }
})
